import React from "react";
import PopupWrapper from "../../../components/PopupWrapper";
import ErrorBoundary from "../../../components/ErrorBoundary";
import TrustLedgerReserveTable from "../../../components/AllTables/TrustLedgerReserveTable";
import { useSelector } from "react-redux";

const TrustLedgerModal = ({ show, setShow }) => {
  const loanId = useSelector((state) => state.account.lenderId);
  return (
    <div>
      <PopupWrapper
        Component={
          <ErrorBoundary>
            <TrustLedgerReserveTable
              loanId={loanId}
              viewAllModal={false}
              className="overflow-visible"
            />
          </ErrorBoundary>
        }
        title="Trust Ledger"
        toShow={show}
        closeEventHandler={() => {
          setShow(false);
        }}
      />
    </div>
  );
};

export default TrustLedgerModal;
